<template>
  <pt-customer-form class="pt-customer-form__page" :isEdit="is_edit" :userLogin="userLogin"></pt-customer-form>
</template>

<script>
import PtCustomerForm from 'cps/customer-manage/pt-customer-manage/pt-customer-form/withData'
export default {
  name: 'pt-customer-form__view',
  components: {
    'pt-customer-form': PtCustomerForm
  },
  props: {
    isEdit: {
      type: String,
      default: ''
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
